import Icon from '@/components/ui/AppIcon';

interface DocumentLibraryItemProps {
  title: string;
  category: string;
  version: string;
  lastModified: string;
  fileSize: string;
  fileType: 'pdf' | 'doc' | 'xls';
  downloads: number;
}

export default function DocumentLibraryItem({
  title,
  category,
  version,
  lastModified,
  fileSize,
  fileType,
  downloads
}: DocumentLibraryItemProps) {
  const fileTypeConfig = {
    pdf: { color: 'bg-error/10 text-error', icon: 'DocumentTextIcon' },
    doc: { color: 'bg-primary/10 text-primary', icon: 'DocumentIcon' },
    xls: { color: 'bg-success/10 text-success', icon: 'TableCellsIcon' }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 hover:shadow-md transition-all duration-base">
      <div className="flex items-start space-x-4">
        <div className={`flex-shrink-0 w-12 h-12 rounded-lg ${fileTypeConfig[fileType].color} flex items-center justify-center`}>
          <Icon name={fileTypeConfig[fileType].icon as any} size={24} variant="outline" />
        </div>
        
        <div className="flex-1 min-w-0">
          <h4 className="text-base font-headline font-bold text-foreground mb-1 truncate">{title}</h4>
          <p className="text-sm font-body text-muted-foreground mb-2">{category}</p>
          
          <div className="flex flex-wrap items-center gap-3 text-xs font-body text-muted-foreground">
            <div className="flex items-center space-x-1">
              <Icon name="DocumentDuplicateIcon" size={14} variant="outline" />
              <span>v{version}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="CalendarIcon" size={14} variant="outline" />
              <span>{lastModified}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="ArrowDownTrayIcon" size={14} variant="outline" />
              <span>{downloads} downloads</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="DocumentIcon" size={14} variant="outline" />
              <span>{fileSize}</span>
            </div>
          </div>
        </div>
        
        <button className="flex-shrink-0 px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-cta font-bold hover:opacity-90 transition-all duration-base flex items-center space-x-2">
          <Icon name="ArrowDownTrayIcon" size={16} variant="outline" />
          <span>Download</span>
        </button>
      </div>
    </div>
  );
}